/**
 *
 * Asynchronously loads the component for Commissioning
 *
 */

import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import('./index'),
  loading: () => null,
});



// WEBPACK FOOTER //
// ./app/containers/Commissioning/Loadable.js